export default __webpack_public_path__ + "static/media/home-dentist-icon-01.03e0f301.svg";